import type { ReactNode } from "react"
import cx from "clsx"
import { useLocation } from "wouter"
import { PortalLayout } from "@rawa/ui/PortalLayout"
import BallotIcon from "../assets/icon-ballot.svg?react"
import CustomizeIcon from "../assets/icon-customize.svg?react"
import ListTreeIcon from "../assets/icon-list-tree.svg?react"
import MapMarkerIcon from "../assets/icon-map-marker.svg?react"
import MobileIcon from "../assets/icon-mobile.svg?react"
import ModulesIcon from "../assets/icon-modules.svg?react"
import QuestionIcon from "../assets/icon-question.svg?react"
import SyncIcon from "../assets/icon-sync.svg?react"
import { AdminAvatarMenu } from "./AdminAvatarMenu"
import { paths } from "../paths"
import styles from "./AdminLayout.module.css"

// Glyphs are the design system's Icons GUI set. Rollout takes a map marker
// because the page is entered by choosing a location, not a program.
const NAV = [
  { href: paths.syncStatus, label: "Sync status", icon: SyncIcon },
  { href: paths.serviceTypes, label: "Service types", icon: ListTreeIcon },
  {
    href: paths.programQuestions,
    label: "Program questions",
    icon: QuestionIcon,
  },
  { href: paths.programConfig, label: "Program config", icon: CustomizeIcon },
  { href: paths.rollout, label: "Rollout", icon: MapMarkerIcon },
  { href: paths.kioskDevices, label: "Kiosk devices", icon: MobileIcon },
  { href: paths.formBuilder, label: "Form builder", icon: BallotIcon },
  { href: paths.modules, label: "Modules", icon: ModulesIcon },
  {
    href: paths.sessionTemplates,
    label: "Session templates",
    icon: BallotIcon,
  },
]

// The signed-in admin chrome: the portal's navy rail and header, carrying the
// admin sections. Shared by every /admin page.
//
// The rail marks its current section, which the practitioner portal's does not
// — seven sections need to say where you are where one does not.
export function AdminLayout({
  children,
  wide,
}: {
  children: ReactNode
  // Opts out of the shared content column. A list of full-width rows needs the
  // room; the forms do not, and stay in the column.
  wide?: boolean
}) {
  const [location] = useLocation()

  return (
    <PortalLayout
      navLabel="Admin"
      items={NAV.map((item) => ({ ...item, current: location === item.href }))}
      header={<AdminAvatarMenu />}
      highlightCurrent
    >
      <div className={cx(styles.content, wide && styles.wide)}>{children}</div>
    </PortalLayout>
  )
}
